/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { Feature } from '../models';
// @ts-ignore
import type { FeatureConfigUpdate } from '../models';
// @ts-ignore
import type { InstallScriptOptions } from '../models';
// @ts-ignore
import type { ListFeatureCompatibilitiesResponse } from '../models';
// @ts-ignore
import type { ListFeatureConfigsResponse } from '../models';
// @ts-ignore
import type { ListFeaturesResponse } from '../models';
// @ts-ignore
import type { Overview } from '../models';
// @ts-ignore
import type { Status } from '../models';
// @ts-ignore
import type { Summary } from '../models';
/**
 * FeaturesAPIApi - axios parameter creator
 * @export
 */
export const FeaturesAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Configures a specific feature with the provided settings.
         * @summary Configures a feature with specific settings.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {FeatureConfigUpdate} featureConfigUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresAPIConfigureFeature: async (organizationId: string, clusterId: string, featureConfigUpdate: FeatureConfigUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('featuresAPIConfigureFeature', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('featuresAPIConfigureFeature', 'clusterId', clusterId)
            // verify required parameter 'featureConfigUpdate' is not null or undefined
            assertParamExists('featuresAPIConfigureFeature', 'featureConfigUpdate', featureConfigUpdate)
            const localVarPath = `/kent/v1alpha/organizations/{organizationId}/clusters/{clusterId}/features:configure`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(featureConfigUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets the installation script for a specific feature.
         * @summary Gets installation script for a specific feature.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} id The ID of the feature to get the installation script for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresAPIGetClusterFeatureInstallScript: async (organizationId: string, clusterId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('featuresAPIGetClusterFeatureInstallScript', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('featuresAPIGetClusterFeatureInstallScript', 'clusterId', clusterId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('featuresAPIGetClusterFeatureInstallScript', 'id', id)
            const localVarPath = `/kent/v1alpha/organizations/{organizationId}/clusters/{clusterId}/features/{id}:getInstallScript`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets a script that installs selected features.  This merges scripts from individual calls to GetFeatureInstallScript.
         * @summary Gets installation script for selected features.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {InstallScriptOptions} installScriptOptions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresAPIGetClusterInstallScript: async (organizationId: string, clusterId: string, installScriptOptions: InstallScriptOptions, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('featuresAPIGetClusterInstallScript', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('featuresAPIGetClusterInstallScript', 'clusterId', clusterId)
            // verify required parameter 'installScriptOptions' is not null or undefined
            assertParamExists('featuresAPIGetClusterInstallScript', 'installScriptOptions', installScriptOptions)
            const localVarPath = `/kent/v1alpha/organizations/{organizationId}/clusters/{clusterId}/features:getInstallScript`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(installScriptOptions, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets detailed information about a specific feature.
         * @summary Gets a specific feature by ID.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} id The ID of the feature to retrieve.  Valid values include: consolidation, workload_right_sizing,  spot_interruption_prediction, rebalancing, pod_mutations.
         * @param {boolean} [invalidateCache] If true, invalidates the preview cache for the rebalancing feature before retrieving data.  This forces a fresh rebalancing preview to be generated.  Only applicable for the rebalancing feature, ignored for other features.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresAPIGetFeature: async (organizationId: string, clusterId: string, id: string, invalidateCache?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('featuresAPIGetFeature', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('featuresAPIGetFeature', 'clusterId', clusterId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('featuresAPIGetFeature', 'id', id)
            const localVarPath = `/kent/v1alpha/organizations/{organizationId}/clusters/{clusterId}/features/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (invalidateCache !== undefined) {
                localVarQueryParameter['invalidateCache'] = invalidateCache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets an installation script with all features enabled by default via GET request.  This is similar to GetClusterInstallScript but uses query parameters instead of request body.
         * @summary Gets installation script via GET with query parameters.
         * @param {boolean} [kubernetesAgent] Whether to include the Kubernetes agent in the installation script. Defaults to true.
         * @param {boolean} [rebalancer] Whether to include the rebalancer feature in the installation script. Defaults to true.
         * @param {boolean} [podMutations] Whether to include the pod mutations feature in the installation script. Defaults to true.
         * @param {boolean} [workloadRightSizing] Whether to include the workload right-sizing feature in the installation script. Defaults to true.
         * @param {boolean} [spotInterruptionPrediction] Whether to include the spot interruption prediction feature in the installation script. Defaults to true.
         * @param {boolean} [clm] Whether to enable the Container Live Migration (CLM) feature. Defaults to false.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresAPIGetInstallScript: async (kubernetesAgent?: boolean, rebalancer?: boolean, podMutations?: boolean, workloadRightSizing?: boolean, spotInterruptionPrediction?: boolean, clm?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/kent/v1alpha/install.sh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (kubernetesAgent !== undefined) {
                localVarQueryParameter['kubernetesAgent'] = kubernetesAgent;
            }

            if (rebalancer !== undefined) {
                localVarQueryParameter['rebalancer'] = rebalancer;
            }

            if (podMutations !== undefined) {
                localVarQueryParameter['podMutations'] = podMutations;
            }

            if (workloadRightSizing !== undefined) {
                localVarQueryParameter['workloadRightSizing'] = workloadRightSizing;
            }

            if (spotInterruptionPrediction !== undefined) {
                localVarQueryParameter['spotInterruptionPrediction'] = spotInterruptionPrediction;
            }

            if (clm !== undefined) {
                localVarQueryParameter['clm'] = clm;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets the installation script for a specific feature at organization level.
         * @summary Gets installation script for a specific feature at organization level.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} id The ID of the feature to get the installation script for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresAPIGetOrganizationFeatureInstallScript: async (organizationId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('featuresAPIGetOrganizationFeatureInstallScript', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('featuresAPIGetOrganizationFeatureInstallScript', 'id', id)
            const localVarPath = `/kent/v1alpha/organizations/{organizationId}/features/{id}:getInstallScript`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets a script that installs selected features at organization level.  This merges scripts from individual calls to GetFeatureInstallScript.
         * @summary Gets installation script for selected features at organization level.
         * @param {string} organizationId The ID of the Organization.
         * @param {InstallScriptOptions} installScriptOptions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresAPIGetOrganizationInstallScript: async (organizationId: string, installScriptOptions: InstallScriptOptions, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('featuresAPIGetOrganizationInstallScript', 'organizationId', organizationId)
            // verify required parameter 'installScriptOptions' is not null or undefined
            assertParamExists('featuresAPIGetOrganizationInstallScript', 'installScriptOptions', installScriptOptions)
            const localVarPath = `/kent/v1alpha/organizations/{organizationId}/features:getInstallScript`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(installScriptOptions, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets an overview combining both summary and features information for a single UI call.
         * @summary Gets overview combining summary and features.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {boolean} [invalidateCache] If true, invalidates the preview cache for the rebalancing feature before retrieving data.  This forces a fresh rebalancing preview to be generated.  Only applicable for the rebalancing feature, ignored for other features.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresAPIGetOverview: async (organizationId: string, clusterId: string, invalidateCache?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('featuresAPIGetOverview', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('featuresAPIGetOverview', 'clusterId', clusterId)
            const localVarPath = `/kent/v1alpha/organizations/{organizationId}/clusters/{clusterId}/overview`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (invalidateCache !== undefined) {
                localVarQueryParameter['invalidateCache'] = invalidateCache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets the main KPIs listed in the header.
         * @summary Gets summary of cluster costs and savings.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresAPIGetSummary: async (organizationId: string, clusterId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('featuresAPIGetSummary', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('featuresAPIGetSummary', 'clusterId', clusterId)
            const localVarPath = `/kent/v1alpha/organizations/{organizationId}/clusters/{clusterId}/summary`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists all available optimization features with Kentroller compatibility information.
         * @summary Lists KENT features with Kentroller compatibility information.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresAPIListFeatureCompatibilities: async (organizationId: string, clusterId: string, pageLimit?: string, pageCursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('featuresAPIListFeatureCompatibilities', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('featuresAPIListFeatureCompatibilities', 'clusterId', clusterId)
            const localVarPath = `/kent/v1alpha/organizations/{organizationId}/clusters/{clusterId}/features:compatibility`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets configuration for all features available in KENT (lightweight, no metrics).
         * @summary Lists configurations for all features without metrics.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} featureId The ID of the feature to retrieve configs for. Use \&quot;-\&quot; to retrieve configs for all features.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresAPIListFeatureConfigs: async (organizationId: string, clusterId: string, featureId: string, pageLimit?: string, pageCursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('featuresAPIListFeatureConfigs', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('featuresAPIListFeatureConfigs', 'clusterId', clusterId)
            // verify required parameter 'featureId' is not null or undefined
            assertParamExists('featuresAPIListFeatureConfigs', 'featureId', featureId)
            const localVarPath = `/kent/v1alpha/organizations/{organizationId}/clusters/{clusterId}/features/{featureId}/configs`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"featureId"}}`, encodeURIComponent(String(featureId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets information about all features available in KENT.
         * @summary Lists all available optimization features.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {boolean} [invalidateCache] If true, invalidates the preview cache for the rebalancing feature before retrieving data.  This forces a fresh rebalancing preview to be generated.  Only applicable for the rebalancing feature, ignored for other features.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresAPIListFeatures: async (organizationId: string, clusterId: string, pageLimit?: string, pageCursor?: string, invalidateCache?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('featuresAPIListFeatures', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('featuresAPIListFeatures', 'clusterId', clusterId)
            const localVarPath = `/kent/v1alpha/organizations/{organizationId}/clusters/{clusterId}/features`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }

            if (invalidateCache !== undefined) {
                localVarQueryParameter['invalidateCache'] = invalidateCache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FeaturesAPIApi - functional programming interface
 * @export
 */
export const FeaturesAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FeaturesAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Configures a specific feature with the provided settings.
         * @summary Configures a feature with specific settings.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {FeatureConfigUpdate} featureConfigUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featuresAPIConfigureFeature(organizationId: string, clusterId: string, featureConfigUpdate: FeatureConfigUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Feature>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featuresAPIConfigureFeature(organizationId, clusterId, featureConfigUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeaturesAPIApi.featuresAPIConfigureFeature']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gets the installation script for a specific feature.
         * @summary Gets installation script for a specific feature.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} id The ID of the feature to get the installation script for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featuresAPIGetClusterFeatureInstallScript(organizationId: string, clusterId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featuresAPIGetClusterFeatureInstallScript(organizationId, clusterId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeaturesAPIApi.featuresAPIGetClusterFeatureInstallScript']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gets a script that installs selected features.  This merges scripts from individual calls to GetFeatureInstallScript.
         * @summary Gets installation script for selected features.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {InstallScriptOptions} installScriptOptions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featuresAPIGetClusterInstallScript(organizationId: string, clusterId: string, installScriptOptions: InstallScriptOptions, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featuresAPIGetClusterInstallScript(organizationId, clusterId, installScriptOptions, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeaturesAPIApi.featuresAPIGetClusterInstallScript']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gets detailed information about a specific feature.
         * @summary Gets a specific feature by ID.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} id The ID of the feature to retrieve.  Valid values include: consolidation, workload_right_sizing,  spot_interruption_prediction, rebalancing, pod_mutations.
         * @param {boolean} [invalidateCache] If true, invalidates the preview cache for the rebalancing feature before retrieving data.  This forces a fresh rebalancing preview to be generated.  Only applicable for the rebalancing feature, ignored for other features.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featuresAPIGetFeature(organizationId: string, clusterId: string, id: string, invalidateCache?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Feature>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featuresAPIGetFeature(organizationId, clusterId, id, invalidateCache, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeaturesAPIApi.featuresAPIGetFeature']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gets an installation script with all features enabled by default via GET request.  This is similar to GetClusterInstallScript but uses query parameters instead of request body.
         * @summary Gets installation script via GET with query parameters.
         * @param {boolean} [kubernetesAgent] Whether to include the Kubernetes agent in the installation script. Defaults to true.
         * @param {boolean} [rebalancer] Whether to include the rebalancer feature in the installation script. Defaults to true.
         * @param {boolean} [podMutations] Whether to include the pod mutations feature in the installation script. Defaults to true.
         * @param {boolean} [workloadRightSizing] Whether to include the workload right-sizing feature in the installation script. Defaults to true.
         * @param {boolean} [spotInterruptionPrediction] Whether to include the spot interruption prediction feature in the installation script. Defaults to true.
         * @param {boolean} [clm] Whether to enable the Container Live Migration (CLM) feature. Defaults to false.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featuresAPIGetInstallScript(kubernetesAgent?: boolean, rebalancer?: boolean, podMutations?: boolean, workloadRightSizing?: boolean, spotInterruptionPrediction?: boolean, clm?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featuresAPIGetInstallScript(kubernetesAgent, rebalancer, podMutations, workloadRightSizing, spotInterruptionPrediction, clm, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeaturesAPIApi.featuresAPIGetInstallScript']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gets the installation script for a specific feature at organization level.
         * @summary Gets installation script for a specific feature at organization level.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} id The ID of the feature to get the installation script for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featuresAPIGetOrganizationFeatureInstallScript(organizationId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featuresAPIGetOrganizationFeatureInstallScript(organizationId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeaturesAPIApi.featuresAPIGetOrganizationFeatureInstallScript']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gets a script that installs selected features at organization level.  This merges scripts from individual calls to GetFeatureInstallScript.
         * @summary Gets installation script for selected features at organization level.
         * @param {string} organizationId The ID of the Organization.
         * @param {InstallScriptOptions} installScriptOptions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featuresAPIGetOrganizationInstallScript(organizationId: string, installScriptOptions: InstallScriptOptions, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featuresAPIGetOrganizationInstallScript(organizationId, installScriptOptions, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeaturesAPIApi.featuresAPIGetOrganizationInstallScript']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gets an overview combining both summary and features information for a single UI call.
         * @summary Gets overview combining summary and features.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {boolean} [invalidateCache] If true, invalidates the preview cache for the rebalancing feature before retrieving data.  This forces a fresh rebalancing preview to be generated.  Only applicable for the rebalancing feature, ignored for other features.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featuresAPIGetOverview(organizationId: string, clusterId: string, invalidateCache?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Overview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featuresAPIGetOverview(organizationId, clusterId, invalidateCache, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeaturesAPIApi.featuresAPIGetOverview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gets the main KPIs listed in the header.
         * @summary Gets summary of cluster costs and savings.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featuresAPIGetSummary(organizationId: string, clusterId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Summary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featuresAPIGetSummary(organizationId, clusterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeaturesAPIApi.featuresAPIGetSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lists all available optimization features with Kentroller compatibility information.
         * @summary Lists KENT features with Kentroller compatibility information.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featuresAPIListFeatureCompatibilities(organizationId: string, clusterId: string, pageLimit?: string, pageCursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListFeatureCompatibilitiesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featuresAPIListFeatureCompatibilities(organizationId, clusterId, pageLimit, pageCursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeaturesAPIApi.featuresAPIListFeatureCompatibilities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gets configuration for all features available in KENT (lightweight, no metrics).
         * @summary Lists configurations for all features without metrics.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} featureId The ID of the feature to retrieve configs for. Use \&quot;-\&quot; to retrieve configs for all features.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featuresAPIListFeatureConfigs(organizationId: string, clusterId: string, featureId: string, pageLimit?: string, pageCursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListFeatureConfigsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featuresAPIListFeatureConfigs(organizationId, clusterId, featureId, pageLimit, pageCursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeaturesAPIApi.featuresAPIListFeatureConfigs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gets information about all features available in KENT.
         * @summary Lists all available optimization features.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {boolean} [invalidateCache] If true, invalidates the preview cache for the rebalancing feature before retrieving data.  This forces a fresh rebalancing preview to be generated.  Only applicable for the rebalancing feature, ignored for other features.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featuresAPIListFeatures(organizationId: string, clusterId: string, pageLimit?: string, pageCursor?: string, invalidateCache?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListFeaturesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featuresAPIListFeatures(organizationId, clusterId, pageLimit, pageCursor, invalidateCache, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeaturesAPIApi.featuresAPIListFeatures']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FeaturesAPIApi - factory interface
 * @export
 */
export const FeaturesAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FeaturesAPIApiFp(configuration)
    return {
        /**
         * Configures a specific feature with the provided settings.
         * @summary Configures a feature with specific settings.
         * @param {FeaturesAPIApiFeaturesAPIConfigureFeatureRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresAPIConfigureFeature(requestParameters: FeaturesAPIApiFeaturesAPIConfigureFeatureRequest, options?: RawAxiosRequestConfig): AxiosPromise<Feature> {
            return localVarFp.featuresAPIConfigureFeature(requestParameters.organizationId, requestParameters.clusterId, requestParameters.featureConfigUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the installation script for a specific feature.
         * @summary Gets installation script for a specific feature.
         * @param {FeaturesAPIApiFeaturesAPIGetClusterFeatureInstallScriptRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresAPIGetClusterFeatureInstallScript(requestParameters: FeaturesAPIApiFeaturesAPIGetClusterFeatureInstallScriptRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.featuresAPIGetClusterFeatureInstallScript(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a script that installs selected features.  This merges scripts from individual calls to GetFeatureInstallScript.
         * @summary Gets installation script for selected features.
         * @param {FeaturesAPIApiFeaturesAPIGetClusterInstallScriptRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresAPIGetClusterInstallScript(requestParameters: FeaturesAPIApiFeaturesAPIGetClusterInstallScriptRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.featuresAPIGetClusterInstallScript(requestParameters.organizationId, requestParameters.clusterId, requestParameters.installScriptOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets detailed information about a specific feature.
         * @summary Gets a specific feature by ID.
         * @param {FeaturesAPIApiFeaturesAPIGetFeatureRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresAPIGetFeature(requestParameters: FeaturesAPIApiFeaturesAPIGetFeatureRequest, options?: RawAxiosRequestConfig): AxiosPromise<Feature> {
            return localVarFp.featuresAPIGetFeature(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, requestParameters.invalidateCache, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets an installation script with all features enabled by default via GET request.  This is similar to GetClusterInstallScript but uses query parameters instead of request body.
         * @summary Gets installation script via GET with query parameters.
         * @param {FeaturesAPIApiFeaturesAPIGetInstallScriptRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresAPIGetInstallScript(requestParameters: FeaturesAPIApiFeaturesAPIGetInstallScriptRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.featuresAPIGetInstallScript(requestParameters.kubernetesAgent, requestParameters.rebalancer, requestParameters.podMutations, requestParameters.workloadRightSizing, requestParameters.spotInterruptionPrediction, requestParameters.clm, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the installation script for a specific feature at organization level.
         * @summary Gets installation script for a specific feature at organization level.
         * @param {FeaturesAPIApiFeaturesAPIGetOrganizationFeatureInstallScriptRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresAPIGetOrganizationFeatureInstallScript(requestParameters: FeaturesAPIApiFeaturesAPIGetOrganizationFeatureInstallScriptRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.featuresAPIGetOrganizationFeatureInstallScript(requestParameters.organizationId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a script that installs selected features at organization level.  This merges scripts from individual calls to GetFeatureInstallScript.
         * @summary Gets installation script for selected features at organization level.
         * @param {FeaturesAPIApiFeaturesAPIGetOrganizationInstallScriptRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresAPIGetOrganizationInstallScript(requestParameters: FeaturesAPIApiFeaturesAPIGetOrganizationInstallScriptRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.featuresAPIGetOrganizationInstallScript(requestParameters.organizationId, requestParameters.installScriptOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets an overview combining both summary and features information for a single UI call.
         * @summary Gets overview combining summary and features.
         * @param {FeaturesAPIApiFeaturesAPIGetOverviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresAPIGetOverview(requestParameters: FeaturesAPIApiFeaturesAPIGetOverviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<Overview> {
            return localVarFp.featuresAPIGetOverview(requestParameters.organizationId, requestParameters.clusterId, requestParameters.invalidateCache, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the main KPIs listed in the header.
         * @summary Gets summary of cluster costs and savings.
         * @param {FeaturesAPIApiFeaturesAPIGetSummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresAPIGetSummary(requestParameters: FeaturesAPIApiFeaturesAPIGetSummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<Summary> {
            return localVarFp.featuresAPIGetSummary(requestParameters.organizationId, requestParameters.clusterId, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists all available optimization features with Kentroller compatibility information.
         * @summary Lists KENT features with Kentroller compatibility information.
         * @param {FeaturesAPIApiFeaturesAPIListFeatureCompatibilitiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresAPIListFeatureCompatibilities(requestParameters: FeaturesAPIApiFeaturesAPIListFeatureCompatibilitiesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListFeatureCompatibilitiesResponse> {
            return localVarFp.featuresAPIListFeatureCompatibilities(requestParameters.organizationId, requestParameters.clusterId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets configuration for all features available in KENT (lightweight, no metrics).
         * @summary Lists configurations for all features without metrics.
         * @param {FeaturesAPIApiFeaturesAPIListFeatureConfigsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresAPIListFeatureConfigs(requestParameters: FeaturesAPIApiFeaturesAPIListFeatureConfigsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListFeatureConfigsResponse> {
            return localVarFp.featuresAPIListFeatureConfigs(requestParameters.organizationId, requestParameters.clusterId, requestParameters.featureId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets information about all features available in KENT.
         * @summary Lists all available optimization features.
         * @param {FeaturesAPIApiFeaturesAPIListFeaturesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresAPIListFeatures(requestParameters: FeaturesAPIApiFeaturesAPIListFeaturesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListFeaturesResponse> {
            return localVarFp.featuresAPIListFeatures(requestParameters.organizationId, requestParameters.clusterId, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.invalidateCache, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for featuresAPIConfigureFeature operation in FeaturesAPIApi.
 * @export
 * @interface FeaturesAPIApiFeaturesAPIConfigureFeatureRequest
 */
export interface FeaturesAPIApiFeaturesAPIConfigureFeatureRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof FeaturesAPIApiFeaturesAPIConfigureFeature
     */
    readonly organizationId: string

    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof FeaturesAPIApiFeaturesAPIConfigureFeature
     */
    readonly clusterId: string

    /**
     * 
     * @type {FeatureConfigUpdate}
     * @memberof FeaturesAPIApiFeaturesAPIConfigureFeature
     */
    readonly featureConfigUpdate: FeatureConfigUpdate
}

/**
 * Request parameters for featuresAPIGetClusterFeatureInstallScript operation in FeaturesAPIApi.
 * @export
 * @interface FeaturesAPIApiFeaturesAPIGetClusterFeatureInstallScriptRequest
 */
export interface FeaturesAPIApiFeaturesAPIGetClusterFeatureInstallScriptRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof FeaturesAPIApiFeaturesAPIGetClusterFeatureInstallScript
     */
    readonly organizationId: string

    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof FeaturesAPIApiFeaturesAPIGetClusterFeatureInstallScript
     */
    readonly clusterId: string

    /**
     * The ID of the feature to get the installation script for.
     * @type {string}
     * @memberof FeaturesAPIApiFeaturesAPIGetClusterFeatureInstallScript
     */
    readonly id: string
}

/**
 * Request parameters for featuresAPIGetClusterInstallScript operation in FeaturesAPIApi.
 * @export
 * @interface FeaturesAPIApiFeaturesAPIGetClusterInstallScriptRequest
 */
export interface FeaturesAPIApiFeaturesAPIGetClusterInstallScriptRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof FeaturesAPIApiFeaturesAPIGetClusterInstallScript
     */
    readonly organizationId: string

    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof FeaturesAPIApiFeaturesAPIGetClusterInstallScript
     */
    readonly clusterId: string

    /**
     * 
     * @type {InstallScriptOptions}
     * @memberof FeaturesAPIApiFeaturesAPIGetClusterInstallScript
     */
    readonly installScriptOptions: InstallScriptOptions
}

/**
 * Request parameters for featuresAPIGetFeature operation in FeaturesAPIApi.
 * @export
 * @interface FeaturesAPIApiFeaturesAPIGetFeatureRequest
 */
export interface FeaturesAPIApiFeaturesAPIGetFeatureRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof FeaturesAPIApiFeaturesAPIGetFeature
     */
    readonly organizationId: string

    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof FeaturesAPIApiFeaturesAPIGetFeature
     */
    readonly clusterId: string

    /**
     * The ID of the feature to retrieve.  Valid values include: consolidation, workload_right_sizing,  spot_interruption_prediction, rebalancing, pod_mutations.
     * @type {string}
     * @memberof FeaturesAPIApiFeaturesAPIGetFeature
     */
    readonly id: string

    /**
     * If true, invalidates the preview cache for the rebalancing feature before retrieving data.  This forces a fresh rebalancing preview to be generated.  Only applicable for the rebalancing feature, ignored for other features.
     * @type {boolean}
     * @memberof FeaturesAPIApiFeaturesAPIGetFeature
     */
    readonly invalidateCache?: boolean
}

/**
 * Request parameters for featuresAPIGetInstallScript operation in FeaturesAPIApi.
 * @export
 * @interface FeaturesAPIApiFeaturesAPIGetInstallScriptRequest
 */
export interface FeaturesAPIApiFeaturesAPIGetInstallScriptRequest {
    /**
     * Whether to include the Kubernetes agent in the installation script. Defaults to true.
     * @type {boolean}
     * @memberof FeaturesAPIApiFeaturesAPIGetInstallScript
     */
    readonly kubernetesAgent?: boolean

    /**
     * Whether to include the rebalancer feature in the installation script. Defaults to true.
     * @type {boolean}
     * @memberof FeaturesAPIApiFeaturesAPIGetInstallScript
     */
    readonly rebalancer?: boolean

    /**
     * Whether to include the pod mutations feature in the installation script. Defaults to true.
     * @type {boolean}
     * @memberof FeaturesAPIApiFeaturesAPIGetInstallScript
     */
    readonly podMutations?: boolean

    /**
     * Whether to include the workload right-sizing feature in the installation script. Defaults to true.
     * @type {boolean}
     * @memberof FeaturesAPIApiFeaturesAPIGetInstallScript
     */
    readonly workloadRightSizing?: boolean

    /**
     * Whether to include the spot interruption prediction feature in the installation script. Defaults to true.
     * @type {boolean}
     * @memberof FeaturesAPIApiFeaturesAPIGetInstallScript
     */
    readonly spotInterruptionPrediction?: boolean

    /**
     * Whether to enable the Container Live Migration (CLM) feature. Defaults to false.
     * @type {boolean}
     * @memberof FeaturesAPIApiFeaturesAPIGetInstallScript
     */
    readonly clm?: boolean
}

/**
 * Request parameters for featuresAPIGetOrganizationFeatureInstallScript operation in FeaturesAPIApi.
 * @export
 * @interface FeaturesAPIApiFeaturesAPIGetOrganizationFeatureInstallScriptRequest
 */
export interface FeaturesAPIApiFeaturesAPIGetOrganizationFeatureInstallScriptRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof FeaturesAPIApiFeaturesAPIGetOrganizationFeatureInstallScript
     */
    readonly organizationId: string

    /**
     * The ID of the feature to get the installation script for.
     * @type {string}
     * @memberof FeaturesAPIApiFeaturesAPIGetOrganizationFeatureInstallScript
     */
    readonly id: string
}

/**
 * Request parameters for featuresAPIGetOrganizationInstallScript operation in FeaturesAPIApi.
 * @export
 * @interface FeaturesAPIApiFeaturesAPIGetOrganizationInstallScriptRequest
 */
export interface FeaturesAPIApiFeaturesAPIGetOrganizationInstallScriptRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof FeaturesAPIApiFeaturesAPIGetOrganizationInstallScript
     */
    readonly organizationId: string

    /**
     * 
     * @type {InstallScriptOptions}
     * @memberof FeaturesAPIApiFeaturesAPIGetOrganizationInstallScript
     */
    readonly installScriptOptions: InstallScriptOptions
}

/**
 * Request parameters for featuresAPIGetOverview operation in FeaturesAPIApi.
 * @export
 * @interface FeaturesAPIApiFeaturesAPIGetOverviewRequest
 */
export interface FeaturesAPIApiFeaturesAPIGetOverviewRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof FeaturesAPIApiFeaturesAPIGetOverview
     */
    readonly organizationId: string

    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof FeaturesAPIApiFeaturesAPIGetOverview
     */
    readonly clusterId: string

    /**
     * If true, invalidates the preview cache for the rebalancing feature before retrieving data.  This forces a fresh rebalancing preview to be generated.  Only applicable for the rebalancing feature, ignored for other features.
     * @type {boolean}
     * @memberof FeaturesAPIApiFeaturesAPIGetOverview
     */
    readonly invalidateCache?: boolean
}

/**
 * Request parameters for featuresAPIGetSummary operation in FeaturesAPIApi.
 * @export
 * @interface FeaturesAPIApiFeaturesAPIGetSummaryRequest
 */
export interface FeaturesAPIApiFeaturesAPIGetSummaryRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof FeaturesAPIApiFeaturesAPIGetSummary
     */
    readonly organizationId: string

    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof FeaturesAPIApiFeaturesAPIGetSummary
     */
    readonly clusterId: string
}

/**
 * Request parameters for featuresAPIListFeatureCompatibilities operation in FeaturesAPIApi.
 * @export
 * @interface FeaturesAPIApiFeaturesAPIListFeatureCompatibilitiesRequest
 */
export interface FeaturesAPIApiFeaturesAPIListFeatureCompatibilitiesRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof FeaturesAPIApiFeaturesAPIListFeatureCompatibilities
     */
    readonly organizationId: string

    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof FeaturesAPIApiFeaturesAPIListFeatureCompatibilities
     */
    readonly clusterId: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof FeaturesAPIApiFeaturesAPIListFeatureCompatibilities
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof FeaturesAPIApiFeaturesAPIListFeatureCompatibilities
     */
    readonly pageCursor?: string
}

/**
 * Request parameters for featuresAPIListFeatureConfigs operation in FeaturesAPIApi.
 * @export
 * @interface FeaturesAPIApiFeaturesAPIListFeatureConfigsRequest
 */
export interface FeaturesAPIApiFeaturesAPIListFeatureConfigsRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof FeaturesAPIApiFeaturesAPIListFeatureConfigs
     */
    readonly organizationId: string

    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof FeaturesAPIApiFeaturesAPIListFeatureConfigs
     */
    readonly clusterId: string

    /**
     * The ID of the feature to retrieve configs for. Use \&quot;-\&quot; to retrieve configs for all features.
     * @type {string}
     * @memberof FeaturesAPIApiFeaturesAPIListFeatureConfigs
     */
    readonly featureId: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof FeaturesAPIApiFeaturesAPIListFeatureConfigs
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof FeaturesAPIApiFeaturesAPIListFeatureConfigs
     */
    readonly pageCursor?: string
}

/**
 * Request parameters for featuresAPIListFeatures operation in FeaturesAPIApi.
 * @export
 * @interface FeaturesAPIApiFeaturesAPIListFeaturesRequest
 */
export interface FeaturesAPIApiFeaturesAPIListFeaturesRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof FeaturesAPIApiFeaturesAPIListFeatures
     */
    readonly organizationId: string

    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof FeaturesAPIApiFeaturesAPIListFeatures
     */
    readonly clusterId: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof FeaturesAPIApiFeaturesAPIListFeatures
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof FeaturesAPIApiFeaturesAPIListFeatures
     */
    readonly pageCursor?: string

    /**
     * If true, invalidates the preview cache for the rebalancing feature before retrieving data.  This forces a fresh rebalancing preview to be generated.  Only applicable for the rebalancing feature, ignored for other features.
     * @type {boolean}
     * @memberof FeaturesAPIApiFeaturesAPIListFeatures
     */
    readonly invalidateCache?: boolean
}

/**
 * FeaturesAPIApi - object-oriented interface
 * @export
 * @class FeaturesAPIApi
 * @extends {BaseAPI}
 */
export class FeaturesAPIApi extends BaseAPI {
    /**
     * Configures a specific feature with the provided settings.
     * @summary Configures a feature with specific settings.
     * @param {FeaturesAPIApiFeaturesAPIConfigureFeatureRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesAPIApi
     */
    public featuresAPIConfigureFeature(requestParameters: FeaturesAPIApiFeaturesAPIConfigureFeatureRequest, options?: RawAxiosRequestConfig) {
        return FeaturesAPIApiFp(this.configuration).featuresAPIConfigureFeature(requestParameters.organizationId, requestParameters.clusterId, requestParameters.featureConfigUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets the installation script for a specific feature.
     * @summary Gets installation script for a specific feature.
     * @param {FeaturesAPIApiFeaturesAPIGetClusterFeatureInstallScriptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesAPIApi
     */
    public featuresAPIGetClusterFeatureInstallScript(requestParameters: FeaturesAPIApiFeaturesAPIGetClusterFeatureInstallScriptRequest, options?: RawAxiosRequestConfig) {
        return FeaturesAPIApiFp(this.configuration).featuresAPIGetClusterFeatureInstallScript(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets a script that installs selected features.  This merges scripts from individual calls to GetFeatureInstallScript.
     * @summary Gets installation script for selected features.
     * @param {FeaturesAPIApiFeaturesAPIGetClusterInstallScriptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesAPIApi
     */
    public featuresAPIGetClusterInstallScript(requestParameters: FeaturesAPIApiFeaturesAPIGetClusterInstallScriptRequest, options?: RawAxiosRequestConfig) {
        return FeaturesAPIApiFp(this.configuration).featuresAPIGetClusterInstallScript(requestParameters.organizationId, requestParameters.clusterId, requestParameters.installScriptOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets detailed information about a specific feature.
     * @summary Gets a specific feature by ID.
     * @param {FeaturesAPIApiFeaturesAPIGetFeatureRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesAPIApi
     */
    public featuresAPIGetFeature(requestParameters: FeaturesAPIApiFeaturesAPIGetFeatureRequest, options?: RawAxiosRequestConfig) {
        return FeaturesAPIApiFp(this.configuration).featuresAPIGetFeature(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, requestParameters.invalidateCache, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets an installation script with all features enabled by default via GET request.  This is similar to GetClusterInstallScript but uses query parameters instead of request body.
     * @summary Gets installation script via GET with query parameters.
     * @param {FeaturesAPIApiFeaturesAPIGetInstallScriptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesAPIApi
     */
    public featuresAPIGetInstallScript(requestParameters: FeaturesAPIApiFeaturesAPIGetInstallScriptRequest = {}, options?: RawAxiosRequestConfig) {
        return FeaturesAPIApiFp(this.configuration).featuresAPIGetInstallScript(requestParameters.kubernetesAgent, requestParameters.rebalancer, requestParameters.podMutations, requestParameters.workloadRightSizing, requestParameters.spotInterruptionPrediction, requestParameters.clm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets the installation script for a specific feature at organization level.
     * @summary Gets installation script for a specific feature at organization level.
     * @param {FeaturesAPIApiFeaturesAPIGetOrganizationFeatureInstallScriptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesAPIApi
     */
    public featuresAPIGetOrganizationFeatureInstallScript(requestParameters: FeaturesAPIApiFeaturesAPIGetOrganizationFeatureInstallScriptRequest, options?: RawAxiosRequestConfig) {
        return FeaturesAPIApiFp(this.configuration).featuresAPIGetOrganizationFeatureInstallScript(requestParameters.organizationId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets a script that installs selected features at organization level.  This merges scripts from individual calls to GetFeatureInstallScript.
     * @summary Gets installation script for selected features at organization level.
     * @param {FeaturesAPIApiFeaturesAPIGetOrganizationInstallScriptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesAPIApi
     */
    public featuresAPIGetOrganizationInstallScript(requestParameters: FeaturesAPIApiFeaturesAPIGetOrganizationInstallScriptRequest, options?: RawAxiosRequestConfig) {
        return FeaturesAPIApiFp(this.configuration).featuresAPIGetOrganizationInstallScript(requestParameters.organizationId, requestParameters.installScriptOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets an overview combining both summary and features information for a single UI call.
     * @summary Gets overview combining summary and features.
     * @param {FeaturesAPIApiFeaturesAPIGetOverviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesAPIApi
     */
    public featuresAPIGetOverview(requestParameters: FeaturesAPIApiFeaturesAPIGetOverviewRequest, options?: RawAxiosRequestConfig) {
        return FeaturesAPIApiFp(this.configuration).featuresAPIGetOverview(requestParameters.organizationId, requestParameters.clusterId, requestParameters.invalidateCache, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets the main KPIs listed in the header.
     * @summary Gets summary of cluster costs and savings.
     * @param {FeaturesAPIApiFeaturesAPIGetSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesAPIApi
     */
    public featuresAPIGetSummary(requestParameters: FeaturesAPIApiFeaturesAPIGetSummaryRequest, options?: RawAxiosRequestConfig) {
        return FeaturesAPIApiFp(this.configuration).featuresAPIGetSummary(requestParameters.organizationId, requestParameters.clusterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists all available optimization features with Kentroller compatibility information.
     * @summary Lists KENT features with Kentroller compatibility information.
     * @param {FeaturesAPIApiFeaturesAPIListFeatureCompatibilitiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesAPIApi
     */
    public featuresAPIListFeatureCompatibilities(requestParameters: FeaturesAPIApiFeaturesAPIListFeatureCompatibilitiesRequest, options?: RawAxiosRequestConfig) {
        return FeaturesAPIApiFp(this.configuration).featuresAPIListFeatureCompatibilities(requestParameters.organizationId, requestParameters.clusterId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets configuration for all features available in KENT (lightweight, no metrics).
     * @summary Lists configurations for all features without metrics.
     * @param {FeaturesAPIApiFeaturesAPIListFeatureConfigsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesAPIApi
     */
    public featuresAPIListFeatureConfigs(requestParameters: FeaturesAPIApiFeaturesAPIListFeatureConfigsRequest, options?: RawAxiosRequestConfig) {
        return FeaturesAPIApiFp(this.configuration).featuresAPIListFeatureConfigs(requestParameters.organizationId, requestParameters.clusterId, requestParameters.featureId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets information about all features available in KENT.
     * @summary Lists all available optimization features.
     * @param {FeaturesAPIApiFeaturesAPIListFeaturesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesAPIApi
     */
    public featuresAPIListFeatures(requestParameters: FeaturesAPIApiFeaturesAPIListFeaturesRequest, options?: RawAxiosRequestConfig) {
        return FeaturesAPIApiFp(this.configuration).featuresAPIListFeatures(requestParameters.organizationId, requestParameters.clusterId, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.invalidateCache, options).then((request) => request(this.axios, this.basePath));
    }
}

